import girderEvents from '@girder/core/events';

export default girderEvents;



// WEBPACK FOOTER //
// ./~/@girder/slicer_cli_web/events.js